module.exports = __webpack_public_path__ + "img/lg_ring_r_c_1_1@3x.60eecda0.png";